import type { Resource } from 'i18next';
import { sliceI18nManifests } from '@/app/providers/i18nManifests';

const sharedI18nResources: Resource = {};

function mergeI18nResources(...resourceSets: readonly Resource[]): Resource {
  const merged: Resource = {};

  for (const resourceSet of resourceSets) {
    for (const [language, namespaces] of Object.entries(resourceSet)) {
      merged[language] ??= {};
      Object.assign(merged[language], namespaces);
    }
  }

  return merged;
}

export const appI18nResources: Resource = mergeI18nResources(
  sharedI18nResources,
  ...sliceI18nManifests.map((manifest) => manifest.resources)
);

export const appI18nNamespaces = Object.freeze([
  ...new Set(sliceI18nManifests.flatMap((manifest) => manifest.namespaces)),
]);
